module.exports = __webpack_public_path__ + "img/img18.e71aae6a.svg";